import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery, useMutation, useAction } from "convex/react";
//import { api } from "../../convex/_generated/api";
import {api} from "./convex/_generated/api"

//import Loader from "../components/Loader";
import "./RecipeDetail.css";

export default function RecipeDetail() {

  const { userId, mealName, suggestionId } = useParams();
  console.log(mealName);


  const navigate = useNavigate();


  const recipe = useQuery(
  api.recipes.getRecipeByMeal,
  suggestionId && mealName
    ? {
        suggestionId,
        mealName,
        userId: userId,
      }
    : "skip"
) || [];

const meal = useQuery(
  api.meals.getMealByName,
  userId && mealName
    ? {
        userId,
        mealName,
      }
    : "skip"
) || [];

  //console.log(meal);

  //console.log(userId);


   //const recipe = recipes[0];
   //console.log(recipe);


  //const markMealCooked = useMutation(
    //api.meals.markMealCooked
  //);
  
  const markMealCooked = useAction(
  api.ai.markMealCooked
);


  const [completedSteps,setCompletedSteps] =
    useState(new Set());


  const [cookedFor,setCookedFor] =
    useState(2);


  const [justCooked,setJustCooked] =
    useState(false);



  //if(recipe === undefined)
    //return (
     // <div className="screen">
       // <Loader/>
      //</div>
    //);


  if(recipe === null)
    return (
      <div className="screen">
        <div className="empty-state">
          <p>Recipe not found.</p>
        </div>
      </div>
    );



  function toggleStep(index){

    setCompletedSteps(prev=>{

      const next = new Set(prev);

      if(next.has(index))
        next.delete(index);
      else
        next.add(index);


      return next;

    });

  }



  async function handleMarkCooked(){

    if(!mealName)
      return;



     await markMealCooked({
        mealName,
        userId: userId,
        cookedFor,
      });


    setJustCooked(true);

  }



return (

<div className="page-bg">
<div className="screen">


<button
className="btn btn-ghost btn-sm"
onClick={()=>navigate(-1)}
style={{ marginBottom: 16 }}
>
← Back
</button>



<div className="eyebrow">

Day {recipe.dayNumber} · {recipe.mealType}

</div>



<h1 className="page-title">
{recipe.mealName}
</h1>




<div className="ticket-meta" style={{ marginBottom: 20 }}>

<span>
⏱ <span className="num">{recipe.cookTime}</span>m
</span>


<span className="pill">
{recipe.difficulty}
</span>


<span>
<span className="num">{recipe.calories}</span> cal
</span>


<span>
 $<span className="num">{recipe.estimatedCost?.toFixed(2) ?? "0.00"}</span>
</span>


</div>




<div className="category-header">
Ingredients
</div>


<div className="ticket">

{
recipe.ingredients?.map(
(item,i)=>(

<div
key={i}
className="grocery-row"
style={{ border: i === recipe.ingredients.length - 1 ? "none" : undefined }}
>

<span className="name">
{item.name}
</span>


<span className="cost">
${item.cost?.toFixed(2) ?? "0.00"}
</span>


</div>

))
}


</div>





<div className="category-header">
Steps
</div>



{
recipe.steps?.map(
(step,i)=>(

<div
key={i}
className="ticket"
onClick={()=>toggleStep(i)}
style={{
cursor:"pointer",
opacity:
completedSteps.has(i)
?0.5
:1,
display: "flex",
gap: 12,
alignItems: "flex-start",
}}
>


<span
className={`checkbox ${completedSteps.has(i) ? "checked" : ""}`}
style={{ flexShrink: 0 }}
>
{
completedSteps.has(i)
?
"✓"
:
i+1
}
</span>


<p
style={{
margin: 0,
textDecoration: completedSteps.has(i) ? "line-through" : "none",
}}
>
{step}
</p>


</div>


))
}




<div
className="ticket"
style={{ marginTop: 20 }}
>

{
justCooked || meal.cooked

?

<p style={{ margin: 0, color: "var(--accent)" }}>
✓ Cooked! Logged.
</p>

:

<>

<div className="field" style={{ marginBottom: 12 }}>
<label>
Cooked for how many people?
</label>


<input
type="number"
value={cookedFor}
onChange={
e=>setCookedFor(
Number(e.target.value)
)
}
/>
</div>


<button
className="btn btn-primary"
onClick={handleMarkCooked}
>
Mark as cooked
</button>

</>

}


</div>



</div>
</div>

);


}